import {http} from "Services/Http/HttpClient";
import FilterBuilder from "Services/Filters/FilterBuilder";

export const getMailTypes = async (filters: any = {}, sort: string = ''): Promise<unknown> => {
    const params: any = {...filters}
    if (sort) {
        params.sort = sort
    }
    const queryString = FilterBuilder.hashMapToQueryString(params)
    const response: any = await http.get('/mail-types' + (queryString ? '?' + queryString : ''))
    const result = response.data._result
    if (Array.isArray(result)) {
        response.data._result = {
            items: result,
            total: response.data._total ?? result.length
        }
    }
    return response
}

export const getMailType = async (id: string): Promise<unknown> => {
    return http.get('/mail-types/' + id)
}
